import { useDefaultFormData as useSharedDefaultFormData } from 'platform/shared/health-apps';
import { isLoggedIn } from 'platform/user/selectors';
import { useSelector } from 'react-redux';
import { useSponsorPrefillSync } from './useSponsorPrefillSync';

/**
 * Seeds the form with feature toggle and login view fields, then syncs the
 * sponsor prefill. The sync depends on the toggle fields, so it must run after
 * the shared hook.
 *
 * @param {{ toggleName: string, formKey: string }[]} toggles - toggle configs
 * @returns {void}
 */
export const useDefaultFormData = toggles => {
  const loggedIn = useSelector(isLoggedIn);

  useSharedDefaultFormData(toggles, {
    extraFields: { 'view:isLoggedIn': loggedIn },
  });
  useSponsorPrefillSync();
};
